// extracted by mini-css-extract-plugin
export var addButton = "_5k-d";
export var bullets = "_5k-e";
export var compact = "_5k-2";
export var container = "_5k-j";
export var extendedWarrantyModal = "_5k-f";
export var learn = "_5k-l";
export var learnMore = "_5k-g";
export var offeringOption = "_5k-3";
export var offeringPrice = "_5k-8";
export var offeringSubtitle = "_5k-7";
export var offeringTitle = "_5k-6";
export var offeringsContainer = "_5k-0";
export var pdpTilesBackground = "_5k-n";
export var plan = "_5k-m";
export var regular = "_5k-1";
export var remove = "_5k-k";
export var seeDetailsIcon = "_5k-i";
export var seeDetailsLink = "_5k-h";
export var selectedOption = "_5k-4";
export var shieldIcon = "_5k-b";
export var shieldIconCompact = "_5k-c";
export var subtitle = "_5k-a";
export var title = "_5k-9";
export var unselectedOption = "_5k-5";